import * as Yup from 'yup';

export const SEGMENTOS_VALIDOS = ['E', 'A', 'T', 'P'];
export const ESTAGIOS_VALIDOS = ['1', '2', '3', '4', '5', '6'];

export const SEGMENTOS_OPCOES = [
  { value: 'E', label: 'Estoque' },
  { value: 'A', label: 'Área Bruta' },
  { value: 'T', label: 'Terreno a empreender' },
  { value: 'P', label: 'Property' },
];

export const ESTAGIOS_OPCOES = [
  { value: '1', label: '1-Estudos' },
  { value: '2', label: '2-Aprovação' },
  { value: '3', label: '3-Obras' },
  { value: '4', label: '4-Registro' },
  { value: '5', label: '5-Lançamento' },
  { value: '6', label: '6-Finalizado' },
];

// Schema completo: required + whitelist (oneOf) + min(1) + test de mútua exclusão.
// LICOES §1.6 — Yup com `.test()` para regra de negócio, não só `.required()`.
export const filtrosSchema = Yup.object()
  .shape({
    codigoGrupoEmpresa: Yup.number().nullable(),
    codigoGrupoGe: Yup.number().nullable(),
    codigoFamilia: Yup.number().nullable(),
    segmentos: Yup.array()
      .of(Yup.string().oneOf(SEGMENTOS_VALIDOS))
      .min(1, 'Selecione ao menos 1 segmento')
      .required('Selecione ao menos 1 segmento'),
    estagios: Yup.array()
      .of(Yup.string().oneOf(ESTAGIOS_VALIDOS))
      .min(1, 'Selecione ao menos 1 estágio')
      .required('Selecione ao menos 1 estágio'),
  })
  .test(
    'mutuamente-exclusivos',
    'GE e Grupo de GE não podem ser usados em conjunto',
    (v) => !(v && v.codigoGrupoEmpresa && v.codigoGrupoGe)
  );
